module.exports = __webpack_public_path__ + "static/media/6.a3644453.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/07/projects/01/6.jpg
// module id = 43
// module chunks = 0